import { Grid, Container } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { FaMale, FaUsers, FaFemale, FaTransgender } from 'react-icons/fa';
import { NepaliNS } from '../../utils/common.utils';
import { lang } from '../../config/app.config';
import Branch, { stats } from '../../models/branch.model';
import { TranslationState } from '../../store/ActionReducers/translation.actionreducer';
import { useSelector } from 'react-redux';

interface Props {
  stats: stats | undefined,
  branch: Branch | undefined
}

const VoterPopulation: React.FC<Props> = props => {

  const { stats, branch } = props;

  const [total, setTotal] = useState('');
  const stateTr = useSelector((state: { translation: TranslationState }) => state.translation);


  // console.log('stats here', stats)
  const calculateTotal = () => {
    if (stats) {
      let total = parseInt(stats.value.female_voters) + parseInt(stats.value.male_voters) + parseInt(stats.value.other_voters);
      setTotal(total.toString());
    }
  }

  useEffect(() => {
    calculateTotal()
  }, [stats]); //eslint-disable-line


  return (
    <Container maxWidth="lg">
      <section className="section-break-2">
        {
          branch ?
            <>
              <h3 className="text-18-primary text-center">
                {branch?.district ? branch.district : branch?.province} {stateTr?.translation ? stateTr?.translation?.election_turnout_number[lang === 'np' ? "value_np" : "value_en"] : ""}
              </h3>
              <p className="text-14 text-center">{branch?.district ? branch.district : branch?.province}</p>
            </> : ''
        }

        {
          stats ?
            <Grid container spacing={3} className="mt-2">
              <Grid item xs={12} md={6} lg={3} >
                <div className="voter-card">
                  <div className="icon text-center">
                    <FaUsers />
                  </div>
                  <p className="text-16-secondary  bold  text-center dev-number">{!total || total === 'NaN' ? '-' : NepaliNS(total)}</p>
                  <h3 className="text-16-primary bold">{stateTr?.translation?.total_voters[lang === 'np' ? "value_np" : "value_en"]}</h3>
                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={3} >
                <div className="voter-card">
                  <div className="icon text-center">
                    <FaFemale />
                  </div>
                  <p className="text-16-secondary  bold  text-center dev-number">{stats?.value?.female_voters ? NepaliNS(stats.value.female_voters || '') : '-'}</p>
                  <h3 className="text-16-primary bold">{stateTr?.translation?.female_voters[lang === 'np' ? "value_np" : "value_en"]}</h3>
                </div>
              </Grid>


              <Grid item xs={12} md={6} lg={3} >
                <div className="voter-card">
                  <div className="icon text-center">
                    <FaMale />
                  </div>
                  <p className="text-16-secondary  bold  text-center dev-number">{stats?.value?.male_voters ? NepaliNS(stats?.value?.male_voters || '') : '-'}</p>
                  <h3 className="text-16-primary bold">{stateTr?.translation?.male_voters[lang === 'np' ? "value_np" : "value_en"]}</h3>
                </div>
              </Grid>


              <Grid item xs={12} md={6} lg={3} >
                <div className="voter-card">
                  <div className="icon text-center">
                    <FaTransgender />
                  </div>
                  <p className="text-16-secondary  bold  text-center dev-number">{stats?.value?.other_voters ? NepaliNS(stats?.value?.other_voters || '') : '-'}</p>
                  <h3 className="text-16-primary bold">{stateTr?.translation?.other_voters[lang === 'np' ? "value_np" : "value_en"]}</h3>
                </div>
              </Grid>
            </Grid> : ''
        }

      </section>
    </Container>
  );
}

export default VoterPopulation;